<template>
  <div 
    :class="{'invalid':errors.has(name)}" 
    :id="'date_' + id" 
    class="input-group date md-form-group" 
    ui-jp="datetimepicker" 
    ui-options="{
            format: 'LT',
            allowInputToggle: true,
            icons: {
              time: 'fa fa-clock-o',
              date: 'fa fa-calendar',
              up: 'fa fa-chevron-up',
              down: 'fa fa-chevron-down',
              previous: 'fa fa-chevron-left',
              next: 'fa fa-chevron-right',
              today: 'fa fa-screenshot',
              clear: 'fa fa-trash',
              close: 'fa fa-remove'
            }
          }">
    <input 
      :id="id" 
      type="text" 
      class="md-input">
        
    <input 
      v-validate="rules"
      :name="name" 
      v-model="timeSelected" 
      type="hidden">
    <label :for="id">{{ label }}</label>
    <span 
      v-show="!errors.has(name)" 
      class="md-input-msg right">{{ description }}</span>
    <span 
      v-show="errors.has(name) && showErrorMsg" 
      class="md-input-msg right">{{ errors.first(name) }}</span>
    <span class="input-group-addon">
      <i 
        class="material-icons" 
        v-html="icon"/>
    </span>
  </div>
</template>
<script>
export default {
    props: {
        time: {
            type: String,
            default: null,
        },
        name: {
            type: String,
            default: 'time-picker',
        },
        label: {
            type: String,
            default: '',
        },
        id: {
            type: String,
            required: true,
        },
        description: {
            type: String,
            default: '',
        },
        dateToCompare: {
            type: String,
            default: null,
        },
        rules: {
            type: Object,
            default: () => {
                return {};
            },
        },
        icon: {
            type: String,
            default: '&#xE425;',
        },
        showErrorMsg: {
            type: Boolean,
            default: true,
        },
        // eslint-disable-next-line vue/require-prop-types
        value: {
            default: '',
        },
    },

    data() {
        return {
            timeSelected: null,
        };
    },

    watch: {
        dateToCompare() {
            this.validate();
        },
    },

    mounted() {
        var vm = this;
        setTimeout(() => {
            try {
                vm.init();
            } catch (err) {
                vm.registerEvent();
            }
        }, 100);
    },

    methods: {
        clear() {
            $(`#date_${this.id}`)
                .data('DateTimePicker')
                .clear();
            this.$emit('onChange', false);
        },

        init() {
            $(`#date_${this.id}`).datetimepicker({
                format: 'LT',
                allowInputToggle: true,
                icons: {
                    time: 'fa fa-clock-o',
                    date: 'fa fa-calendar',
                    up: 'fa fa-chevron-up',
                    down: 'fa fa-chevron-down',
                    previous: 'fa fa-chevron-left',
                    next: 'fa fa-chevron-right',
                    today: 'fa fa-screenshot',
                    clear: 'fa fa-trash',
                    close: 'fa fa-remove',
                },
            });

            this.registerEvent();

            if (this.value) {
                this.setValue(this.value);
            }
        },

        registerEvent() {
            var vm = this;
            $(`#date_${this.id}`).on('dp.change', val => {
                if (!val.date) {
                    vm.timeSelected = null;
                } else {
                    vm.timeSelected = val.date.format('h:mm A');
                }
                vm.$emit('onChange', val.date, vm.id);
                vm.$emit('input', val.date);
            });

            $(`#date_${this.id}`).on('dp.hide', val => {
                var inputValue = $(`#${this.id}`).val();
                if (inputValue.trim() == '') {
                    vm.clear();
                } else {
                    if (!val.date) {
                        vm.timeSelected = null;
                    } else {
                        vm.timeSelected = val.date.format('h:mm A');
                    }
                    vm.$emit('onChange', val.date, vm.id);
                }
            });
        },

        setValue(date) {
            var vm = this;
            try {
                $(`#date_${this.id}`)
                    .data('DateTimePicker')
                    .date(date);
            } catch (e) {
                vm.init();
                setTimeout(() => {
                    $(`#date_${vm.id}`)
                        .data('DateTimePicker')
                        .date(date);
                }, 200);
            }
        },

        hide() {
            $(`#date_${this.id}`)
                .data('DateTimePicker')
                .hide();
        },

        hasError() {
            this.hide();
            this.validate();
            return this.errors.length > 0;
        },

        validate() {
            return this.$validator.validateAll().then(r => {});
        },
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/timepicker.vue